<template>
    <div class="relative cursor-pointer" @click="toggle">
        <video :src="src" class="mx-auto max-h-64" autoplay muted loop playsinline></video>
        <transition name="template" enter-active-class="ease-out duration-200" enter-from-class="opacity-0" enter-to-class="opacity-100" leave-active-class="ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
            <div v-if="paused" class="absolute inset-0 flex">
                <div class="relative w-full h-full flex items-center justify-center">
                    <div class="bg-gray-600 opacity-50 absolute inset-0"></div>
                    <i class="fa-solid fa-circle-pause text-white text-4xl"></i>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import Debouncer from '../Classes/Utils/Debouncer';

export default {
    props: {
        src: {
            type: String,
            required: true,
        },
    },

    watch: {
        src() {
            this.reset();
        }
    },

    data() {
        return {
            debouncer: new Debouncer(200),
            forcePause: false,
            paused: false,
        }
    },

    computed: {
        video() {
            return this.$el.querySelector('video');
        },
    },

    mounted() {
        this.$nextTick(() => {
            this.playOrPauseWhenInView();
        });

        document.addEventListener('scroll', this.playOrPauseWhenInView);
    },

    beforeUnmount() {
        document.removeEventListener('scroll', this.playOrPauseWhenInView);
    },

    methods: {
        toggle() {
            if (this.video.paused) {
                this.forcePause = false;

                return this.play();
            }

            this.forcePause = true;

            this.pause();
        },

        play() {
            this.paused = false;
            this.video.currentTime = 0;
            this.video.play();
        },

        pause() {
            this.paused = true;
            this.video.pause();
        },

        inView() {
            var rect = this.video.getBoundingClientRect();

            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
                rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
            );
        },

        playOrPauseWhenInView() {
            this.pause();

            this.debouncer.handle(() => {
                if (this.inView() && ! this.forcePause) {
                    return this.play();
                }

                return this.pause();
            })
        },
        reset() {
            this.paused = false;
            this.forcePause = false;
        },
    },
}
</script>
